import { PerkCategory } from '@/types/Perk';

export const ALL_PERK_CATEGORIES: PerkCategory[] = [
  {
    displayText: 'Beauty & Wellness',
    value: 'beauty-and-wellness'
  },
  {
    displayText: 'Fashion',
    value: 'fashion'
  },
  {
    displayText: 'Foodies',
    value: 'foodies'
  },
  {
    displayText: 'Home & Entertaining',
    value: 'home-and-entertaining'
  },
  {
    displayText: 'Hospitality',
    value: 'hospitality'
  },
  {
    displayText: 'Just for Moms',
    value: 'just-for-moms'
  },
  {
    displayText: 'Travel',
    value: 'travel'
  }
];
